// src/pages/grupos/ConvitesGrupos.jsx
import { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import BotaoVoltar from "../../components/BotaoVoltar";
import api from "../../services/api";

export default function ConvitesGrupos() {
  const [convites, setConvites] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const r = await api.get("/grupos/convites/");
      setConvites(r.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const responder = async (id, status) => {
    try {
      await api.post(`/grupos/convite/${id}/responder/`, { status });
      load();
    } catch (e) {
      console.error(e);
      alert("Erro ao responder convite.");
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <>
      <Navbar />

      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="fw-bold mb-0">Convites Recebidos</h2>
          <BotaoVoltar to="/grupos" />
        </div>

        {loading && <p>Carregando...</p>}

        {!loading && convites.length === 0 && <p>Nenhum convite pendente.</p>}

        <div className="list-group">
          {convites.map((c) => (
            <div
              key={c.id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div>
                <strong>{c.grupo_nome}</strong>
                <div className="text-muted small">
                  Enviado por {c.remetente_nome}
                </div>
              </div>

              <div className="d-flex gap-2">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => responder(c.id, "aceito")}
                >
                  Aceitar
                </button>

                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => responder(c.id, "recusado")}
                >
                  Recusar
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
